import React from 'react'


const PL3Wine = (props) => {
    let whiteWine = props.whiteWine
    let redWine = props.redWine

    console.log(whiteWine)
    console.log(redWine)

    const processGlassPricing = (priceArray) => {
        console.log(priceArray)

        let glassPrice, bottlePrice, splitPrice

       
        priceArray.map(price => {
            if (price.name === "glass" || price.name === "Glass"){
                glassPrice = price.price
            } else if (price.name === "bottle" || price.name === "Bottle"){
                bottlePrice = price.price
            } else if (price.name === "split" || price.name === "Split"){
                splitPrice = price.price
            }
        })
        
        console.log(glassPrice)
        console.log(bottlePrice)
        console.log(splitPrice)

        

        //glassPrice = Math.trunc(parseInt(glassPrice))

        if (glassPrice && bottlePrice) {
            glassPrice = parseFloat(glassPrice)
            bottlePrice = parseFloat(bottlePrice)
          
           
            console.log(glassPrice)
            console.log(bottlePrice)
           
            if (Number.isInteger(glassPrice)){
                glassPrice = Math.trunc(glassPrice)
            }
            if (Number.isInteger(bottlePrice)){
                bottlePrice = Math.trunc(bottlePrice)
            }
            
            return (
                <span className="wine-price">{glassPrice} | {bottlePrice}</span>
            )
        } else if (glassPrice && !bottlePrice) {
            glassPrice = parseFloat(glassPrice)
            if (Number.isInteger(glassPrice)){
                glassPrice = Math.trunc(glassPrice)
            }
            return (<span className="wine-price">{glassPrice}</span>)
        } else if (splitPrice) {
            splitPrice = parseFloat(splitPrice)
            if (Number.isInteger(splitPrice)){
                splitPrice = Math.trunc(splitPrice)
            }
            return (<><span className="wine-price">{splitPrice}</span> <span className="split-tag">split</span></>)
        }

    }
    
    return (
        <div className="wine-page-two-column">
            
                <div className="col-left">
                    <div className="column pl7 whitewine right">
                        
                        <div className="red-wines">
                        {redWine.map(item => (
                                <div className="wine-item">
                                    <div className="wine-item-name">
                                        {item.name}
                                    </div>
                                    <div className="wine-item-style red">{item.location}</div>
                                    <div className="wine-item-description">
                                        {item.description}
                                    </div>
                                    <div>   
                                        {processGlassPricing(item.containers)}
                                    </div>
                                </div>
                            ))}
                           
                        </div>
                        
                    </div>
                </div>
                <div className="col-right white-wine-container">
                    <div className="column pl7 redwine left">
                        <div className="white-wines pl3">
                        {whiteWine.map(item => (
                                <div className="wine-item pl7">
                                    <div className="wine-item-name">{item.name}</div>
                                    <div className="wine-item-style white">{item.location}</div>
                                    <div className="wine-item-description">{item.description}</div>
                                    <div>   
                                        {processGlassPricing(item.containers)}
                                    </div>
                                    
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
        </div>
    )
}
export default PL3Wine